// isTransient.ts
import { TRPCClientError } from '@trpc/client';

/** HTTP codes that usually mean “temporary, try again soon”. */
const RETRYABLE_HTTP = new Set([408, 429, 502, 503, 504]);

/** tRPC `data.code` values that map to those same situations. */
const RETRYABLE_TRPC_CODES = new Set(['TIMEOUT', 'TOO_MANY_REQUESTS', 'BAD_GATEWAY', 'SERVICE_UNAVAILABLE', 'GATEWAY_TIMEOUT'] as const);

/**
 * True  → tell TanStack Query to re‑queue the request
 * False → bubble the error up to your UI layer
 */
export function isTransient(err: unknown): boolean {
    /* 1. Network / CORS failures coming from fetch -> usually TypeError   */
    if (err instanceof TypeError) return true;

    /* 2. Proper tRPC error object                                         */
    if (err instanceof TRPCClientError) {
        const { code, httpStatus } = err.data ?? {};

        // Prefer explicit HTTP status when present
        if (typeof httpStatus === 'number') {
            return RETRYABLE_HTTP.has(httpStatus);
        }

        // Fall back to the symbolic error code
        return typeof code === 'string' && RETRYABLE_TRPC_CODES.has(code as any);
    }

    /* 3. Anything else looks permanent */
    return false;
}
